/* Bureaulys : étapes de suivi en français, sans noms de villes d'origine (page /apps/track123) */
(function () {
  var FR = {
    "order received successfully": "Commande reçue",
    "shipment information received by warehouse electronically": "Informations d'expédition transmises à l'entrepôt",
    "package ready for shipping from warehouse": "Colis préparé",
    "package finished": "",
    "package shipped out from warehouse": "Colis parti de l'entrepôt",
    "leave the warehouse": "",
    "processing at sorting center": "En cours de tri",
    "inbound in sorting center": "",
    "departed from sorting center": "Parti du centre de tri",
    "outbound in sorting center": "",
    "last-mile delivery forecast": "Transporteur de livraison en cours d'attribution",
    "arrived at departure transport hub": "Arrivé au centre d'expédition international",
    "departed from departure transport hub": "Parti du centre d'expédition international",
    "left from departure transport hub": "Parti du centre d'expédition international",
    "export customs clearance started": "Formalités d'export en cours",
    "export customs clearance complete": "Formalités d'export terminées",
    "export customs clearance completed": "Formalités d'export terminées",
    "export clearance success": "",
    "import clearance success": "",
    "departed from departure country/region": "Parti du pays d'expédition",
    "arrived at destination country/region": "Arrivé dans le pays de destination",
    "arrived at destination country": "Arrivé dans le pays de destination",
    "import customs clearance started": "Dédouanement en cours",
    "import customs clearance complete": "Dédouanement terminé",
    "import customs clearance completed": "Dédouanement terminé",
    "arrived at linehaul office": "Arrivé au centre de distribution",
    "arrived at local delivery center": "Arrivé au centre de livraison",
    "handed over to last mile carrier": "Remis au transporteur de livraison",
    "received by local delivery company": "Pris en charge par le transporteur de livraison",
    "out for delivery": "En cours de livraison",
    "delivered": "Livré",
    "left from departure country/region": "Parti du pays d'expédition",
    "leaving from departure country/region": "Départ du pays d'expédition",
    "departed from transit country/region": "Parti du pays de transit",
    "depart from transit country or district": "",
    "awaiting for transit to final delivery office": "",
    "package arrived at facility of the local delivery company": "Arrivé chez le transporteur de livraison",
    "your shipment is in process at sorting center": "En cours de tri",
    "arrived at destination transport hub": "Arrivé au centre de réception international",
    "departed from destination transport hub": "Parti du centre de réception international",
    "available for pickup": "Disponible en point de retrait",
    "arrived at pickup point": "Arrivé en point de retrait",
    "fr": "",
    "package delivered": "Livré",
    "your shipment has been delivered successfully": "",
    "your shipment is out for delivery": "",
    "leaving transit country/region": "Départ du pays de transit",
    "parcel outbound from transit facility": "",
    "arrived in transit country/region": "Arrivé dans le pays de transit",
    "arrive attransit country or district.": "",
    "arrive at transit country or district": "",
    "handed over from linehaul office": "",
    "at destination country/region": "Arrivé dans le pays de destination",
    "arrived at linehual office": "",
    "import clearance start": "Dédouanement en cours",
    "import clearance complete": "Dédouanement terminé",
    "in transit": "En transit"
  };
  var LIEU = /(\bTown\b|\bCity\b|\bDistrict\b|\bProvince\b|Shenzhen|Guangzhou|Dongguan|Yiwu|Hangzhou|Shanghai|Beijing|Ningbo|Xiamen|Foshan|Jinhua|Hong Kong|^China$|^CN$)/i;
  function traduire(texte) {
    var morceaux = texte.split(",");
    if (morceaux.length < 2 && !FR.hasOwnProperty(texte.trim().toLowerCase())) return null;
    var sortie = [], change = false;
    for (var i = 0; i < morceaux.length; i++) {
      var m = morceaux[i].trim(), cle = m.toLowerCase();
      if (!m) { change = true; continue; }
      if (LIEU.test(m) && m.split(" ").length <= 4) { change = true; continue; }
      if (FR.hasOwnProperty(cle)) { change = true; m = FR[cle]; if (!m) continue; }
      if (sortie.indexOf(m) === -1) sortie.push(m); else change = true;
    }
    if (!change || !sortie.length) return null;
    return sortie.join(", ");
  }
  var vus = new WeakSet();
  function parcourir(racine) {
    var w = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      if (vus.has(n)) continue;
      var p = n.parentElement;
      if (!p || p.closest("script, style") || !p.closest("#track123-app")) continue;
      var t = n.nodeValue;
      if (!t || t.length > 400) continue;
      var r = traduire(t);
      if (r !== null) { n.nodeValue = r; }
      vus.add(n);
    }
  }
  function lancer() {
    try { parcourir(document.body); } catch (e) {}
    new MutationObserver(function () { try { parcourir(document.body); } catch (e) {} })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", lancer); else lancer();
})();
